"use client";

import { Box, CircularProgress } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { useEffect, useRef, useState } from "react";

interface LoadingProps {
  sx?: SxProps<Theme>;
}

export default function Loading({ sx }: LoadingProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [topOffset, setTopOffset] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      const offset = containerRef.current.offsetTop;
      setTopOffset(offset);
    }
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: `calc(100vh - ${topOffset}px)`,
        ...sx,
      }}>
      <CircularProgress color="primary" />
    </Box>
  );
}

export function LoadingSmall({ sx }: LoadingProps) {
  return <Loading sx={{ height: "100%", my: 2, ...sx }} />;
}

export function LoadingMask() {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        bgcolor: "rgba(25, 25, 25, 0.5)",
        zIndex: 9999,
      }}>
      <Loading />
    </Box>
  );
}